<template>
  <app-dialog
    v-model="openModel"
    content-class="dialogGuaranteeLongTermCare guaranteeModal"
    @onClose="$emit('onClose')"
  >
    <template v-slot:title>
      <h1 class="dialogGuaranteeLongTermCare-title">介護保障</h1>
    </template>
    <v-card class="dialogGuaranteeLongTermCare-content">
      <v-card-text class="dialogGuaranteeLongTermCare-content">
        <div class="his-tbl_wrapper">
          <table>
            <thead>
              <tr>
                <th colspan="5">保障内容</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th></th>
                <th>Ｐ型</th>
              </tr>
              <tr>
                <td>１口あたりの<br />保障額</td>
                <td data-label="Ｐ型"><span>１００</span>万円<br /></td>
              </tr>
              <tr>
                <td>ご加入条件</td>
                <td data-label="Ｐ型">
                  J型・K型のいずれかとセットで加入が必要
                </td>
              </tr>
              <tr>
                <td>口数の制限</td>
                <td data-label="Ｐ型">1～5口の範囲内</td>
              </tr>
            </tbody>
          </table>
          <div>
            <div class="pointTitle">特長</div>
            <div class="pointBox">
              <dl>
                <dt>1</dt>
                <dd>
                  「要介護2から5相当」と<br />診断され、その状態が90日を超えて継続している場合に<br />保険金をお支払い*
                </dd>
              </dl>
              <dl>
                <dt>2</dt>
                <dd>
                  ご家族も加入できるので、<br /><strong>親の介護リスク</strong
                  >にも<br />備えられる
                </dd>
              </dl>
              <dl>
                <dt>3</dt>
                <dd>
                  お手ごろな<br />
                  <strong>保険料で大きな保障が</strong
                  ><br />得られる
                </dd>
              </dl>
            </div>
          </div>
        </div>
        <p class="dialogGuaranteeLongTermCare-note">公的介護保険制度の要介護認定の対象とならない場合であっても、損保ジャパンが定める所定の要介護状態（公的介護保険制度における要介護2から5の状態が目安）となり、その要介護状態が要介護状態に該当した日からその日を含めて90日を超えて継続した場合には、保険金をお支払いします。
        </p>
      </v-card-text>
    </v-card>
  </app-dialog>
</template>

<script>
export default {
  name: 'DialogGuaranteeLongTermCare',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    openModel: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>

<style lang="scss">
.dialogGuaranteeLongTermCare {
  width: 690px;
  max-width: 700px;
  &-content {
    &.v-card__text {
      padding: 0 30px 20px;
    }
  }
  &-title {
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: center;
    color: #333;
    margin-top: 15px;
    margin-bottom: 5px;
    width: 100%;
  }
  &-note {
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.54;
    letter-spacing: normal;
    text-align: left;
    color: #333;
    display: inline-block;
    padding-left: 23px;
    padding-right: 10px;
    &::before {
      content: '*';
      display: inline-block; /* Needed to add space between the bullet and the text */
      width: 15px; /* Also needed for space (tweak if needed) */
      margin-left: -15px; /* Also needed for space (tweak if needed) */
    }
  }
}
</style>
